import React  from 'react';

import HealthIcon from "core/gd-components/health/health-icon/health-icon";

export default function renderBooleanGroupTListHeader1(id, props) {
    return <HealthIcon className="rag-icon" value={props.data.value}/>;
}